document.addEventListener('DOMContentLoaded', function() {
  const readMoreLink = document.querySelector('.read-more-link');
  const descriptionContent = document.querySelector('.description-content');

  if (readMoreLink && descriptionContent) {
    readMoreLink.addEventListener('click', function(e) {
      e.preventDefault();
      descriptionContent.classList.toggle('expanded');
      readMoreLink.textContent = descriptionContent.classList.contains('expanded') ? 'Read Less' : 'Read More';
    });
  }
});
